import React from "react";
import styles from "./CurrentDateTimeButton.module.css";

/**
 * Shared "Current Time" button that autofills the current local date and/or time.
 *
 * @param {function} [onDateChange] - Called with a Date object (device local time)
 * @param {function} [onTimeChange] - Called with "HH:mm" string (device local time)
 * @param {boolean} [disabled] - Disables the button
 * @param {string} [className] - Optional additional CSS class
 */
const CurrentDateTimeButton = ({
  onDateChange,
  onTimeChange,
  disabled = false,
  className = "",
}) => {
  const handleClick = () => {
    const now = new Date();

    if (onDateChange) {
      onDateChange(now);
    }

    if (onTimeChange) {
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      onTimeChange(`${hours}:${minutes}`);
    }
  };

  return (
    <button
      className={`${styles.currentDateTimeButton} ${className}`}
      type="button"
      onClick={handleClick}
      disabled={disabled}
    >
      {onDateChange && onTimeChange ? "Current Date/Time" : "Current Time"}
    </button>
  );
};

export default CurrentDateTimeButton;
